"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuth = setAuth;

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

function setAuth(auth) {
  return {
    type: _ActionTypes.SET_AUTH,
    auth: auth
  };
}